<div class="button-bar mb-4">
  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="openConfirmDialog(uploader)"
    [matTooltip]="
      'PRODUCTS.BTN.IMPORT.TOOLTIP'
        | translate
          : {
              requestSize: maxRequestSizeMiB,
              unit: 'MiB',
              fileSize: maxFileSizeMiB
            }
    "
  >
    <mat-icon>add</mat-icon>
    {{ "PRODUCTS.BTN.IMPORT.TITLE" | translate }}
  </button>
  <div *ngIf="(isUploading$ | async) === true" class="ms-4 me-auto">
    <mat-spinner
      color="primary"
      diameter="40"
      mode="indeterminate"
    ></mat-spinner>
  </div>
  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="remove()"
    [disabled]="selection.isEmpty()"
  >
    <mat-icon>delete</mat-icon>
    {{ "SHARED.DELETE" | translate }}
  </button>
</div>
<div>
  <form [formGroup]="uploadForm" style="display: none">
    <input
      formControlName="file"
      id="file"
      type="file"
      multiple
      class="form-control"
      #uploader
      (change)="onFileChange($event)"
    />
  </form>
  <app-list-table
    [isLoading]="!!(isLoading$ | async)"
    [numberOfItems]="(totalImages$ | async) ?? 0"
    [columns]="displayedColumns"
    [rowIdName]="'name'"
    [dataSource]="productImagesTableSource"
    [customCellValue]="getCellValue"
    (selectionChangedEvent)="selection = $event"
    (sortChangedEvent)="handleSortChanged($event)"
  >
  </app-list-table>
</div>
